<template>
    <div class="box validate-coupon">
        <h3>{{ t('dashboard-validateCoupon-title') }}</h3>
        <confirm
            id="confirm-use-coupon"
            ref="confirmUseCoupon"
            @confirm="confirmCoupon"
        >
            <template slot="title">{{ t('dashboard-validateCoupon-confirm_use_title') }}</template>
            <template slot="body">
                <div v-html="t('dashboard-validateCoupon-confirm_use_body', { 0: coupon.description || coupon.text })"></div>
            </template>
        </confirm>
        <info-modal
            id="confirm-coupon-used"
            ref="couponUsed"
            @close="reset(true)"
        >
            <template slot="title">
                <div class="fa fa-check"></div>
                {{ t('dashboard-validateCoupon-used_success_title') }}</template
            >
            <template slot="body">
                <div v-html="t('dashboard-validateCoupon-used_success_body', { 0: coupon.description || coupon.text, 1: couponCode })"></div>
            </template>
        </info-modal>
        <div class="row">
            <div class="col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="couponCode"
                    @keyup.enter="valid ? useCoupon() : isValid()"
                />
            </div>
            <div class="col-sm-12">
                <span class="message message-error" v-if="valid === false">
                    <span v-if="error == 'expired'"
                        >{{ t('dashboard-validateCoupon-error_expired') }}
                        <human-date
                            :date="error_date"
                            :format="t('dates-format_day_month_short_time')"
                        ></human-date
                    ></span>
                    <span v-if="error == 'not-yet-valid'"
                        >{{ t('dashboard-validateCoupon-error_not_yet_valid') }}
                        <human-date
                            :date="error_date"
                            :format="t('dates-format_day_month_short_time')"
                        ></human-date
                    ></span>
                    <span v-if="error == 'used'">{{ t('dashboard-validateCoupon-error_used') }}</span>
                    <span v-if="error == 'not-found'">{{ t('dashboard-validateCoupon-error_not_found') }}</span>
                </span>
                <span class="message message-success" v-if="valid === true"
                    >{{ t('dashboard-validateCoupon-valid_coupon') }}</span
                >
                <button
                    class="btn btn-primary"
                    @click.prevent="isValid"
                    v-if="!valid"
                    :disabled="loading"
                >
                    <span class="fa fa-search" v-if="!loading"></span>
                    <span class="fa fa-spin fa-spinner" v-if="loading"></span>
                    {{ t('dashboard-validateCoupon-validate_button') }}
                </button>
                <button
                    class="btn btn-success"
                    @click.prevent="useCoupon"
                    v-if="valid"
                    :disabled="loading"
                >
                    <span class="fa fa-search" v-if="!loading"></span>
                    <span class="fa fa-spin fa-spinner" v-if="loading"></span>
                    {{ t('dashboard-validateCoupon-use_button') }}
                </button>
            </div>
        </div>
        <div class="message"></div>
    </div>
</template>
<script>
import keviApi from "../../keviApi";

export default {
    props: {},
    data: function () {
        return {
            couponCode: null,
            valid: null,
            error: null,
            error_date: null,
            coupon: {
                text: null,
                code: null,
                used: null,
            },
            loading: false,
        };
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid: function () {
            this.$store.dispatch("coupons/validateCode", this.couponCode);
            // this.loading = true;
            // var options = keviApi.getOptions("coupons/"+this.couponCode+"/is-valid");
            // window.mixpanel?.track("Coupon - is valid begin", {"code":this.couponCode});
            // this.$http(options).then(function(response){
            //   this.loading = false;
            //   if (response.status === 200) {
            //     if (response.body.status === "valid") {
            //       this.valid = true;
            //       this.coupon = response.body.coupon;
            //       this.coupon.used = (response.body.coupon.used === "0") ? false : true;
            //     } else {
            //       this.valid = false;
            //       this.error = response.body.error;
            //       if (this.error === "not-yet-valid") {
            //         this.error_date = response.body.valid_from_date;
            //       }
            //       if (this.error === "expired") {
            //         this.error_date = response.body.expiration_date;
            //       }
            //       this.coupon = {
            //         text: null,
            //         code: null,
            //         used: null
            //       };
            //     }
            //     window.mixpanel?.track("Coupon - is valid success", {"valid":this.valid});
            //
            //   } else {
            //     window.mixpanel?.track("Coupon - is valid error");
            //   }
            //   window.mixpanel?.track('Validate Coupon', {
            //     client_id: this.coupon.clients_id || null,
            //     coupon_code_id: this.coupon.id || null,
            //     coupon_id: this.coupon.coupons_id || null,
            //     coupon_name: this.coupon.text || null,
            //     coupon_code: this.coupon.code || null,
            //     coupon_valid_date: this.coupon.expiration_date || null,
            //     coupon_used: this.coupon.used || false,
            //     coupon_is_valid: this.valid,
            //     coupon_state: this.error || 'success'
            //   });
            // })
        },
        reset: function (resetCouponCode) {
            if (resetCouponCode) {
                this.couponCode = null;
            }
            this.valid = null;
            this.coupon = {
                text: null,
                code: null,
                user: null,
            };
        },
        useCoupon: function () {
            window.mixpanel?.track("Coupon - use begin", {
                code: this.coupon.code,
            });
            this.$refs.confirmUseCoupon.open();
        },
        confirmCoupon: function () {
            this.loading = true;
            var options = keviApi.getOptions(
                "coupons/" + this.couponCode + "/use",
                "POST",
            );
            window.mixpanel?.track("Coupon - use confirm", {
                code: this.coupon.code,
            });
            this.$http(options).then(function (response) {
                this.loading = false;
                if (response.status === 200) {
                    this.$refs.couponUsed.open();
                    this.coupon = response.body.coupon;
                    this.coupon.used =
                        response.body.coupon.used === "0" ? false : true;
                    if (this.coupon.used) {
                        window.mixpanel?.track("Coupon - use used", {
                            code: this.coupon.code,
                        });
                    }
                    window.mixpanel?.track("Use Coupon", {
                        coupon_name: this.coupon.text,
                        coupon_code: this.coupon.code,
                        coupon_state: this.coupon.used,
                    });
                }
            });
        },
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
